import React from "react";
import StackKit from "../kit/stack";
import TypoGraphyKit from "../kit/typoGraphy";
import { SxProps, Theme } from "@mui/material";
/**
 * BoxLayoutContent
 *
 * کامپوننتی برای نمایش محتوای قالب‌بندی‌شده با عنوان و المان‌های سفارشی.
 * این کامپوننت واکنش‌گرا طراحی شده و در نمایشگرهای کوچک، چیدمان افقی را به چیدمان عمودی تغییر می‌دهد.
 *
 * ویژگی‌ها:
 * - پشتیبانی از عنوان و عنصر عنوان دلخواه (titleElement)
 * - امکان ارسال استایل سفارشی (sxStyle)
 * - چیدمان واکنش‌گرا با StackKit
 *
 * @component
 * @param {React.ReactNode} children محتوای داخلی کامپوننت
 * @param {string} [title] عنوان متنی بخش
 * @param {React.ReactNode} [titleElement] عنصر سفارشی عنوان
 * @param {SxProps<Theme>} [sxStyle] استایل سفارشی برای بخش محتوا
 * @returns JSX.Element
 */
interface BoxLayoutContentProps{
  children: React.ReactNode;
  title?: string;
  titleElement?: React.ReactNode;
  sxStyle?: SxProps<Theme>;
} 


const BoxLayoutContent = ({children,title,sxStyle,titleElement,}:BoxLayoutContentProps) => {
  return (
    <StackKit direction="column" sx={{width: "100%",px: { xs: 2, sm: 3, md: 4 },py: { xs: 1, sm: 2 },}} gap={2}>
      {/* Title Section */}
      {title && (
        <StackKit direction={{ xs: "column", sm: "row" }} sx={{width: { xs: "100%", sm: "60%", md: "40%" },gap: "10px",mb: 2,}}>
          <TypoGraphyKit variant="h6" sx={{fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },textAlign: { xs: "center", sm: "right" },}}>
            {title}
          </TypoGraphyKit>
        </StackKit>
      )}

      {/* Custom Title Element (e.g. Filter Controls, Buttons, etc.) */}
      {titleElement && (
        <StackKit direction={{ xs: "column", sm: "row" }} sx={{width: "100%",gap: "10px",mb: { xs: 2, md: 3 },alignItems: { xs: "flex-start", sm: "center" },}}>
          {titleElement}
        </StackKit>
      )}

      {/* Content Section */}
      <StackKit direction={{ xs: "column", md: "row" }} justifyContent={{ xs: "center", md: "space-between" }} alignItems={{ xs: "stretch", md: "center" }} sx={{width: "100%",flexWrap: "wrap",gap: { xs: 2, sm: 3 },...sxStyle,}}>
        {children}
      </StackKit>
    </StackKit>
  );
};

export default BoxLayoutContent;